import { HttpClient } from '@shared/adapters/HttpClient';

export interface ShippingDataErrorRequest {
  customer: {
    address: {
      address1: string;
      address2?: string;
      zip: string;
      city: string;
      province?: string;
      country_code: string;
    };
  };
}

export interface ShippingDataErrorResponse {
  success: boolean;
  message: string;
}

export class ShippingDataErrorApiAdapter {
  constructor(private httpClient: HttpClient) {}

  async solveShippingDataError(
    orderId: number,
    data: ShippingDataErrorRequest
  ): Promise<ShippingDataErrorResponse> {
    try {
      console.log(
        '🔍 ShippingDataErrorApiAdapter - Solving shipping data error:',
        {
          orderId,
          data,
        }
      );

      const response = await this.httpClient.put(
        `/orders/${orderId}/solve-error/shipping`,
        data
      );

      console.log('🔍 ShippingDataErrorApiAdapter - Response:', response);

      return {
        success: true,
        message:
          response.message || 'Datos de envío actualizados correctamente',
      };
    } catch (error: any) {
      console.log('🔍 ShippingDataErrorApiAdapter - Error:', error);
      throw error;
    }
  }
}
